import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import {
  getCertificateTransactionInfo,
  getCertificateTransactionInfoFailure,
  getCertificateTransactionInfoSuccess,
} from './mp-flight-transaction-service.actions';
import { map, switchMap } from 'rxjs';
import { MPFlightTransactionService } from '../mp-flight-transaction.service';
import { GenericResponseStatus } from '../../../models/generic-response-status';

@Injectable()
export class MPFlightTransactionServiceEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly mpFlightTransactionService: MPFlightTransactionService = inject(MPFlightTransactionService);

  constructor() {}

  getTransactionInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCertificateTransactionInfo),
      switchMap(({ certificateNumbers }) => {
        return this.mpFlightTransactionService.getCertificateTransactionInfo(certificateNumbers).pipe(
          map((response) => {
            if (response.status === GenericResponseStatus.SUCCESS || response.status === GenericResponseStatus.PARTIAL_FAILURE) {
              return getCertificateTransactionInfoSuccess(response);
            } else {
              return getCertificateTransactionInfoFailure(response);
            }
          })
        );
      })
    )
  );
}
